/**
 * Domain Entity: ExpenseItem
 * Represents a travel expense item (KRW)
 */
export class ExpenseItem {
  constructor({
    id = 'exp_' + Math.random().toString(36).substring(2, 9),
    category = 'food', // 'food', 'transport', 'ticket', 'shopping', 'etc'
    title,
    amount = 0,
    createdAt = new Date().toISOString()
  }) {
    this.id = id;
    this.category = category;
    this.title = (title || '').trim();
    this.amount = Math.max(0, Number(amount) || 0);
    this.createdAt = createdAt;
  }

  toJSON() {
    return {
      id: this.id,
      category: this.category,
      title: this.title,
      amount: this.amount,
      createdAt: this.createdAt
    };
  }

  static fromJSON(json) {
    if (!json) return null;
    return new ExpenseItem({
      id: json.id,
      category: json.category || 'food',
      title: json.title || '',
      amount: json.amount || 0,
      createdAt: json.createdAt || new Date().toISOString()
    });
  }
}
